import { LogoutOutlined } from "@mui/icons-material";
import {
	Avatar,
	Box,
	ButtonBase,
	ClickAwayListener,
	List,
	ListItemButton,
	ListItemText,
	Paper,
	Popper,
	Stack, Typography,
	useTheme
} from '@mui/material';
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import { useRef, useState } from 'react';
import { useTranslation } from "react-i18next";
import useUserAction from "../../../hooks/user/useUserAction";
import useUserData from "../../../hooks/user/useUserData";
import { NAVIGATION } from "../../../locales/components/namespaces";
import Transitions from "../../@extended/transitions.jsx";
import MainCard from "../../mui/general/cards/mainCard/mainCard.jsx";

const AccountMenu = () => {
	const theme = useTheme();
	const { t } = useTranslation(NAVIGATION)
	const [open, setOpen] = useState(false);
	const anchorRef = useRef(null);
	const { userLogout } = useUserAction()
	const { username } = useUserData()
	const handleToggle = () => {
		setOpen((prevOpen) => !prevOpen);
	};
	const handleClose = (event) => {
		if (anchorRef.current && anchorRef.current.contains(event.target)) {
			return;
		}
		setOpen(false);
	};
	
	return (
		<Box sx={{ flexShrink: 0, ml: 0.75 }}>
			<ButtonBase
				sx={{
					borderRadius: 1,
					'&:hover': {
						bgcolor: 'secondary.lighter',
						color: 'primary.darker'
					},
					'&:focus-visible': {
						outline: `2px solid ${theme.palette.secondary.dark}`,
						outlineOffset: 2
					}
				}}
				aria-label="open profile"
				ref={anchorRef}
				aria-controls={open ? 'profile-grow' : undefined}
				aria-haspopup="true"
				onClick={handleToggle}
			>
				<Stack direction="row" spacing={2} alignItems="center" sx={{ p: 0.1 }}>
					<Avatar alt="profile user" size="xs" sx={{ backgroundColor: theme.palette.secondary.main }}/>
				</Stack>
			</ButtonBase>
			<Popper
				placement="bottom-end"
				open={open}
				anchorEl={anchorRef.current}
				role={undefined}
				transition
				disablePortal
			>
				{({ TransitionProps }) => (
					<Transitions type="grow" position="top-right" in={open} {...TransitionProps}>
						<Paper
							sx={{
								boxShadow: theme.customShadows.z1,
								width: 290,
								minWidth: 240,
								maxWidth: 290,
								[theme.breakpoints.down('md')]: {
									maxWidth: 250
								}
							}}
						>
							<ClickAwayListener onClickAway={handleClose}>
									<List component="nav" sx={{ p: 0, '& .MuiListItemIcon-root': { minWidth: 32 } }}>
										<ListItem>
											<ListItemText primary={
												<Typography variant="caption" color="secondary"
															sx={{ fontWeight: 'bold' }}>
													{username}
												</Typography>
											}
											/>
										</ListItem>
										<ListItemButton onClick={userLogout}>
											<ListItemIcon>
												<LogoutOutlined/>
											</ListItemIcon>
											<ListItemText primary={t("Logout")}/>
										</ListItemButton>
									</List>
							</ClickAwayListener>
						</Paper>
					</Transitions>
				)}
			</Popper>
		</Box>
	);
};

export default AccountMenu;
